var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 58.667H5.33337C4.24004 58.667 3.33337 57.7603 3.33337 56.667C3.33337 55.5737 4.24004 54.667 5.33337 54.667H58.6667C59.76 54.667 60.6667 55.5737 60.6667 56.667C60.6667 57.7603 59.76 58.667 58.6667 58.667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.6663V58.6663H38V10.6663C38 7.73301 36.8 5.33301 33.2 5.33301H30.8C27.2 5.33301 26 7.73301 26 10.6663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26.6663V58.6663H18.6667V26.6663C18.6667 23.733 17.6 21.333 14.4 21.333H12.2667C9.06667 21.333 8 23.733 8 26.6663Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 40.0003V58.667H56V40.0003C56 37.067 54.9334 34.667 51.7334 34.667H49.6C46.4 34.667 45.3334 37.067 45.3334 40.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.6184872d3c757cddb851b2c2194450e8.svg";
export { ForwardRef as ReactComponent };